module.exports = __webpack_public_path__ + "img/AOD3.08ac3ae6.jpg";